export default __webpack_public_path__ + "static/media/advantage1.809c2f22.png";